/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010030 受注明細照会
 */

import { Column, Query } from "@material-table/core";
import { Box } from "@mui/material";
import {
  B000200ByJanCdShohinNm2,
  B000200ShohinNm1,
  B010020Get,
  catchRestError,
} from "clients/rest";
import { B000150TokuiNmr } from "clients/rest/b000/B000150";
import { B000151NonyuNm } from "clients/rest/b000/B000151";
import { B010012Get } from "clients/rest/b010/B010012";
import { B010030Find, B010030FindRequest } from "clients/rest/b010/B010030";
import { B010030TogetsuYm } from "clients/rest/b010/B010030";
import {
  SText,
  SCodeSelect,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  SCodeCheck,
  msgState,
  SLink,
  SLinkHandler,
} from "components";
import {
  B010030JuchuStatus,
  B010030Shutsuryokujun,
  getSCode,
  JuchuKbnView,
  JuchuStatus,
  JuchuUchiwakeKbn,
  SCode,
  ShokaKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000120,
  B000130,
  B000140,
  B000150,
  B000200,
  B000202,
  B010010InputData,
  B010012,
} from "pages";
import {
  createRef,
  RefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { mapIds } from "services";
import { editKbn, juchuStatus, setshohinKbn } from "services/codes";
import { date, dateWithSlashAt } from "services/DateService";
import { focusState, navigateTypeState, useFocus } from "states";
import { B010012Props } from "./B010012";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
  page: number;
  pageSize: number;
  sort: string[];
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNmr: string;
  shokaKbn: SCode;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  juchuStatus: SCode;
  shutsuryokujun: SCode;
  shukayoteiYmdFrom: string;
  shukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  chumonNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shohinCd: string;
  shohinNm1: string;
  janCd: string;
  shohinNm2: string;
  setshohinCheck: string;
  shohinNmr: string;
  tokuiShokuchiKbn: string;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: number;
  uchiwakeKbn: number;
  shohinCd: string;
  shohinNm: string;
  juchuKbn: number;
  juchuYmd: string;
  shukayoteiYmd: string;
  juchudenpyoNo: string;
  juchudenpyoNoF: string;
  juchugyoNo: string;
  chumonNo: string;
  tokuiNm: string;
  nonyuNm: string;
  juchusu: number;
  urisu: number;
  shainNm: string;
  juchuKin: number;
  arariKin: number;
  arariritsu: number;
  juchuStatus: number;
  bumonNm: string;
  setshohinKbn: number;
}>;

// TODO システムマスタの当月の初日の取得方法
// フィールドの初期値を設定する。
const defaultFields: Fields = {
  juchuYmdFrom: "",
  juchuYmdTo: "",
  seisakuYmdFrom: "",
  seisakuYmdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNmr: "",
  shokaKbn: getSCode(ShokaKbn, "0"),
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  juchuStatus: getSCode(JuchuStatus, "1"),
  shutsuryokujun: getSCode(B010030Shutsuryokujun, "0"),
  shukayoteiYmdFrom: "",
  shukayoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  chumonNo: "",
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  shohinCd: "",
  shohinNm1: "",
  janCd: "",
  shohinNm2: "",
  setshohinCheck: "0",
};

const focusId = "B010030";

// B010030 受注明細照会
export const B010030 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

// 検索条件を格納するステート
const B010030State = atom<SearchedFields>({
  key: "B010030State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

const Page = (props: Props) => {
  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 非活性/活性制御の定義
  const [disabledJuchuJuchuDetail, setDisabledJuchuDetail] = useState(true);

  // テーブルRowの定義
  const selectedData = useRef<Data>({});

  // ナビゲーション
  const navigate = useNavigate();
  const setMenuNavigate = useSetRecoilState(navigateTypeState);

  // 検索条件フィールドの定義
  const [searchedFields, setSearchedFields] = useRecoilState(B010030State);

  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 1ページの行数
  const pageSize = 10;
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // セット構成品を保持
  const kosei = useRef<B010012Props>();
  // 全行のリンク要素を保持
  const linkRefs = useRef<RefObject<SLinkHandler>[]>([]);
  // クリックしたリンクの行番号を保持
  const [linkId, setLinkId] = useState<number>(0);

  // テーブルを定義する。
  const columns: Column<Data>[] = useMemo(
    () => [
      { field: "gyoNo", title: "行　", width: "2.5rem", align: "right" },
      { field: "uchiwakeKbn", hidden: true },
      {
        field: "uchiwakeKbnView",
        title: "区分",
        width: "4rem",
        render: (data) => {
          return getSCode(JuchuUchiwakeKbn, data.uchiwakeKbn?.toString() ?? "0")
            ?.label;
        },
      },
      {
        field: "shohinCd",
        title: "商品コード",
        width: "7rem",
        render: (data) => {
          let id = (data as any).tableData?.id ?? 0;
          // セット構成品の場合のみリンクに変更する。
          if (data.setshohinKbn === setshohinKbn.set) {
            // 各行のリンク要素を紐づける。
            linkRefs.current[id] = createRef<SLinkHandler>();
            return (
              <SLink
                label={data.shohinCd}
                ref={linkRefs.current[id]}
                onClick={() => handleClickLink(data)}
                dialog={<B010012 {...kosei.current} />}
              />
            );
          }
          return data.shohinCd;
        },
      },
      { field: "shohinNm", title: "商品名", width: "20rem" },
      {
        field: "juchuKbnView",
        title: "受注区分",
        width: "4rem",
        render: (data) => {
          return getSCode(JuchuKbnView, data.juchuKbn?.toString() ?? "0")
            ?.label;
        },
      },
      { field: "juchuKbn", hidden: true },
      {
        field: "juchuYmd",
        title: "受注日",
        width: "6rem",
        render: (data) => {
          if (data.juchuYmd! !== null && data.juchuYmd! !== "") {
            return dateWithSlashAt(data.juchuYmd!);
          }
        },
      },
      {
        field: "shukayoteiYmd",
        title: "発送日",
        width: "6rem",
        render: (data) => {
          if (data.shukayoteiYmd! !== null && data.shukayoteiYmd! !== "") {
            return dateWithSlashAt(data.shukayoteiYmd!);
          }
        },
      },
      { field: "juchudenpyoNo", hidden: true },
      { field: "juchudenpyoNoF", title: "受注No.", width: "8rem" },
      { field: "juchugyoNo", hidden: true },
      { field: "chumonNo", title: "客先No.", width: "8rem" },
      { field: "tokuiNm", title: "得意先", width: "20rem" },
      { field: "nonyuNm", title: "納入先", width: "20rem" },
      {
        field: "juchusu",
        title: "受注数　",
        width: "8rem",
        align: "right",
        render: (data) => data.juchusu?.toLocaleString(),
      },
      {
        field: "urisu",
        title: "出荷数　",
        width: "4rem",
        align: "right",
        render: (data) => data.urisu?.toLocaleString(),
      },
      { field: "shainNm", title: "受注担当者", width: "8rem" },
      {
        field: "juchuKin",
        title: "受注金額　",
        width: "6rem",
        align: "right",
        render: (data) => data.juchuKin?.toLocaleString(),
      },
      { field: "bumonNm", title: "受注担当部門", width: "8rem" },
      {
        field: "arariKin",
        title: "粗利金額　",
        width: "6rem",
        align: "right",
        render: (data) => data.arariKin?.toLocaleString(),
      },
      {
        field: "arariritsu",
        title: "粗利率　",
        width: "6rem",
        align: "right",
        render: (data) => {
          if (!data.arariritsu) {
            return "";
          }
          return data.arariritsu + "%";
        },
      },
      {
        field: "juchuStatusView",
        title: "受注ステータス",
        width: "6.5rem",
        render: (data) => {
          return getSCode(
            B010030JuchuStatus,
            data.juchuStatus?.toString() ?? "0"
          )?.label;
        },
      },
      { field: "juchuStatus", hidden: true },
      { field: "setshohinKbn", hidden: true },
    ],
    []
  );

  // 初期表示イベント
  useEffect(() => {
    // 検索条件が保存されている
    if (searchedFields.searched) {
      const fields = searchedFields.fields;
      if (typeof fields !== "undefined") {
        methods.setValue("juchuYmdFrom", fields.juchuYmdFrom);
        methods.setValue("juchuYmdTo", fields.juchuYmdTo);
        methods.setValue("seisakuYmdFrom", fields.seisakuYmdFrom);
        methods.setValue("seisakuYmdTo", fields.seisakuYmdTo);
        methods.setValue("bumonCdFrom", fields.bumonCdFrom);
        methods.setValue("bumonCdTo", fields.bumonCdTo);
        methods.setValue("juchudenpyoNoFrom", fields.juchudenpyoNoFrom);
        methods.setValue("juchudenpyoNoTo", fields.juchudenpyoNoTo);
        methods.setValue("tokuiCd", fields.tokuiCd);
        methods.setValue("tokuishitenCd", fields.tokuishitenCd);
        methods.setValue("tokuiNmr", fields.tokuiNmr);
        methods.setValue("shokaKbn", fields.shokaKbn);
        methods.setValue("shodaibun", fields.shodaibun);
        methods.setValue("shochubun", fields.shochubun);
        methods.setValue("shoshobun", fields.shoshobun);
        methods.setValue("juchuStatus", fields.juchuStatus);
        methods.setValue("shutsuryokujun", fields.shutsuryokujun);
        methods.setValue("shukayoteiYmdFrom", fields.shukayoteiYmdFrom);
        methods.setValue("shukayoteiYmdTo", fields.shukayoteiYmdTo);
        methods.setValue("eigyoCdFrom", fields.eigyoCdFrom);
        methods.setValue("eigyoCdTo", fields.eigyoCdTo);
        methods.setValue("shainCdFrom", fields.shainCdFrom);
        methods.setValue("shainCdTo", fields.shainCdTo);
        methods.setValue("chumonNo", fields.chumonNo);
        methods.setValue("nonyuCd", fields.nonyuCd);
        methods.setValue("nonyushitenCd", fields.nonyushitenCd);
        methods.setValue("nonyuNm", fields.nonyuNm);
        methods.setValue("shohinCd", fields.shohinCd);
        methods.setValue("shohinNm1", fields.shohinNm1);
        methods.setValue("janCd", fields.janCd);
        methods.setValue("shohinNm2", fields.shohinNm2);
        methods.setValue("setshohinCheck", fields.setshohinCheck);
        setSearched(true);
        return;
      }
    }
    // 受注日の初期表示イベント
    (async () => {
      await B010030TogetsuYm(methods, navigate, setMsg);
      methods.setValue("juchuYmdTo", date());
      focus(1);
    })();
  }, []);

  // リンククリック時、セット構成品を再レンダリングした後でダイアログを開く。
  useEffect(() => {
    if (linkId < 0) return;
    linkRefs.current[linkId]?.current?.handleOpen();
  }, [linkId]);

  // リンククリックイベント
  const handleClickLink = (data: any) => {
    const b010012Props: B010012Props = {
      editKbn: editKbn.reference,
      fields: {},
      data: [],
    };
    kosei.current = b010012Props;
    if (typeof data.juchudenpyoNo === "undefined") return;
    if (typeof data.juchugyoNo === "undefined") return;
    B010012Get({
      juchudenpyoNo: data.juchudenpyoNo,
      juchugyoNo: data.juchugyoNo,
    })
      .then((value) => {
        b010012Props.fields = {
          setshohinCd: value.data.shohinCd,
          setshohinNm: value.data.shohinNm,
          juchusu: value.data.juchusu.toString(),
        };
        b010012Props.data = value.data.b000030GetJuchumeikoseiResponseList.map(
          (value) => ({
            juchugyoNo: data.gyoNo?.toString() ?? "",
            juchukoseigyoNo: Number(value.gyo),
            shohinCd: value.shohinCd,
            aiteCd: value.aiteCd,
            shohinNm: value.shohinNm,
            vol: value.vol,
            sotosunW: value.sotosunW,
            sotosunH: value.sotosunH,
            uchisunW: value.uchisunW,
            uchisunH: value.uchisunH,
            koseisu: value.koseisu,
            hitsuyosu: value.hitsuyosu,
            kanosu: value.kanosu,
            jodaitanka: value.jodaitanka,
            juchutanka: value.juchutanka,
            kakeritsu: value.kakeritsu,
            juchuKin: value.juchuKin,
            sokoCd: value.sokoCd,
            sokoNm: value.sokoNm,
            meisaikoseiBikoCd: value.meisaikoseiBikoCd,
            meisaikoseiBiko: value.meisaikoseiBiko,
            kazeiKbn: Number(value.kazeiKbn),
            janCd: value.janCd,
            tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
            tenyuryokujuchuKbn: Number(value.tenyuryokujuchuKbn),
            basejodaitanka: value.jodaitanka,
            basejuchutanka: value.juchutanka,
          })
        );
        kosei.current = b010012Props;
        setLinkId(-1);
        setLinkId(data.tableData?.id ?? 0);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // ボタン非活性化
    setDisabledJuchuDetail(true);
    // 選択されているデータを空にする
    selectedData.current = {};
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButtun = () => {
    // 初期化
    handleResetSearch();
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // テーブル行ダブルクリック/詳細ボタンクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // 受注データの検索を行う
    B010020Get({ juchudenpyoNo: data.juchudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B010010InputData = {
          editKbn: editKbn.reference,
          juchu: value.data,
        };
        if (data.juchuStatus === juchuStatus.juchuRegistered) {
          inputData.editKbn = editKbn.update;
        }
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 受注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  //詳細ボタンクリック時
  const handleShowDatail = () => {
    // 受注データの検索を行う
    B010020Get({ juchudenpyoNo: selectedData.current.juchudenpyoNo })
      .then((value) => {
        const inputData: B010010InputData = {
          editKbn: editKbn.reference,
          juchu: value.data,
        };
        if (selectedData.current.juchuStatus === juchuStatus.juchuRegistered) {
          inputData.editKbn = editKbn.update;
        }
        setSearchedFields({ searched: true, fields: methods.getValues() });
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行選択時イベント
  const handleRowClick = (_: any, rowData: any) => {
    const disabled = typeof rowData === "undefined";
    setDisabledJuchuDetail(disabled);
    selectedData.current = rowData;
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 出力順の値に応じたソート処理
      let order;
      if (fields.shutsuryokujun?.value === "0") {
        order = ["juchuYmd,asc", "juchudenpyoNo,asc", "juchugyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "1") {
        order = ["shukayoteiYmd,asc", "juchudenpyoNo,asc", "juchugyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "2") {
        order = ["shohinCd,asc", "juchudenpyoNo,asc", "juchugyoNo,asc"];
      } else if (fields.shutsuryokujun?.value === "3") {
        order = [
          "tokuiCd,asc",
          "tokuishitenCd,asc",
          "juchudenpyoNo,asc",
          "juchugyoNo,asc",
        ];
      } else if (fields.shutsuryokujun?.value === "4") {
        order = ["juchudenpyoNo,asc", "juchugyoNo,asc"];
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B010030FindRequest = {
        juchuYmdFrom: fields.juchuYmdFrom,
        juchuYmdTo: fields.juchuYmdTo,
        seisakuYmdFrom: fields.seisakuYmdFrom,
        seisakuYmdTo: fields.seisakuYmdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
        juchudenpyoNoTo: fields.juchudenpyoNoTo,
        tokuiCd: fields.tokuiCd,
        tokuishitenCd: fields.tokuishitenCd,
        shokaKbn: fields.shokaKbn?.value,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        juchuStatus: fields.juchuStatus?.value,
        shukayoteiYmdFrom: fields.shukayoteiYmdFrom,
        shukayoteiYmdTo: fields.shukayoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        chumonNo: fields.chumonNo,
        nonyuCd: fields.nonyuCd,
        nonyushitenCd: fields.nonyushitenCd,
        shohinCd: fields.shohinCd,
        janCd: fields.janCd,
        setshohinCheck: fields.setshohinCheck,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        // ["出力項目名,順番(asc/desc", ...]
        sort: order,
      };

      // API呼び出し
      B010030Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // 得意先.諸口が「1：諸口」の場合活性化する
  const isTokuiShokuchi: boolean = methods.watch("tokuiShokuchiKbn") !== "1";
  //商品中分類が入力されているかどうか
  const existShochubun: boolean = methods.watch("shochubun") !== "";
  //商品中分類が入力されているかどうか
  const existShoshobun: boolean = methods.watch("shoshobun") !== "";
  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="受注明細照会"
        gridTemplateColumns="7rem 3rem 2rem 1rem 1rem 1rem 2rem 1rem 4rem 14rem 5rem 7rem 5rem 2rem 1rem 2rem 5rem 14rem"
      >
        <SLabel>受注日</SLabel>
        <SDateField name="juchuYmdFrom" {...register(1)} gridColumn="span 4" />
        <SText>～</SText>
        <SDateField name="juchuYmdTo" {...register(2)} gridColumn="span 3" />

        <Box gridColumn="span 2" />

        <SLabel>発送日</SLabel>
        <SDateField
          name="shukayoteiYmdFrom"
          {...register(17)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SDateField
          name="shukayoteiYmdTo"
          {...register(18)}
          gridColumn="span 2"
        />

        <Box />

        <SLabel>製作日</SLabel>
        <SDateField
          name="seisakuYmdFrom"
          {...register(3)}
          gridColumn="span 4"
        />
        <SText>～</SText>
        <SDateField name="seisakuYmdTo" {...register(4)} gridColumn="span 3" />

        <Box gridColumn="span 2" />

        <SLabel>営業所</SLabel>
        <SNumberField
          name="eigyoCdFrom"
          code
          size={6}
          {...register(19)}
          gridColumn="span 2"
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdFrom", data.eigyoCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="eigyoCdTo"
          code
          size={6}
          gridColumn="span 2"
          {...register(20)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdTo", data.eigyoCd);
          }}
        />

        <Box />

        <SLabel>受注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          {...register(5)}
          gridColumn="span 4"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          gridColumn="span 3"
          {...register(6)}
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
        />

        <Box gridColumn="span 2" />

        <SLabel>受注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          {...register(21)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          gridColumn="span 2"
          {...register(22)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
        />

        <Box />

        <SLabel>受注No</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(7)}
          gridColumn="span 4"
        />
        <SText>～</SText>
        <SNumberField
          name="juchudenpyoNoTo"
          code
          size={10}
          {...register(8)}
          gridColumn="span 3"
        />

        <Box gridColumn="span 2" />

        <SLabel>客先No</SLabel>
        <STextField
          name="chumonNo"
          code
          size={11}
          {...register(23)}
          gridColumn="span 2"
        />

        <Box gridColumn="span 4" />

        <SLabel>得意先</SLabel>
        <SNumberField
          name="tokuiCd"
          code
          size={6}
          onBlur={() => B000150TokuiNmr(methods, navigate, setMsg)}
          {...register(9)}
          gridColumn="span 2"
        />
        <SNumberField
          name="tokuishitenCd"
          code
          size={4}
          gridColumn="span 4"
          onBlur={() => B000150TokuiNmr(methods, navigate, setMsg)}
          {...register(10)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCd", data.tokuiCd);
            methods.setValue("tokuishitenCd", data.tokuishitenCd);
            methods.setValue("tokuiNmr", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmr" size={40} gridColumn="span 3" disabled />

        <Box />

        <SLabel>納入先</SLabel>
        <SNumberField
          name="nonyuCd"
          code
          size={6}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
          {...register(24)}
          gridColumn="span 1"
        />
        <SNumberField
          name="nonyushitenCd"
          code
          size={4}
          gridColumn="span 3"
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
          {...register(25)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCd", data.tokuiCd);
            methods.setValue("nonyushitenCd", data.tokuishitenCd);
            methods.setValue("nonyuNm", data.tokuiNmr);
          }}
        />
        <STextField
          name="nonyuNm"
          size={40}
          disabled={isTokuiShokuchi}
          gridColumn="span 2"
        />

        <SLabel>消化区分</SLabel>
        <SCodeSelect
          options={ShokaKbn}
          name="shokaKbn"
          {...register(11)}
          gridColumn="span 3"
        />

        <Box gridColumn="span 14" />

        <SLabel>商品分類</SLabel>
        <SNumberField
          name="shodaibun"
          code
          size={3}
          required={existShochubun}
          {...register(12)}
        />
        <SNumberField
          name="shochubun"
          code
          size={3}
          gridColumn="span 2"
          required={existShoshobun}
          {...register(13)}
        />
        <SNumberField
          name="shoshobun"
          code
          size={3}
          gridColumn="span 3"
          {...register(14)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
        />

        <Box gridColumn="span 4" />

        <SLabel>商品</SLabel>
        <SNumberField
          name="shohinCd"
          code
          size={10}
          onBlur={() => B000200ShohinNm1(methods, navigate, setMsg)}
          {...register(26)}
          gridColumn="span 3"
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNm1", data.shohinNmr);
          }}
        />
        <STextField name="shohinNm1" size={40} disabled gridColumn="span 3" />

        <SLabel>受注ステータス</SLabel>
        <SCodeSelect
          options={JuchuStatus}
          name="juchuStatus"
          {...register(15)}
          gridColumn="span 3"
        />

        <Box gridColumn="span 7" />

        <SLabel>JANコード</SLabel>
        <SNumberField
          name="janCd"
          code
          size={13}
          onBlur={() => B000200ByJanCdShohinNm2(methods, navigate, setMsg)}
          {...register(27)}
          gridColumn="span 2"
        />
        <STextField name="shohinNm2" size={40} disabled gridColumn="span 4" />

        <SLabel>出力順</SLabel>
        <SCodeSelect
          options={B010030Shutsuryokujun}
          name="shutsuryokujun"
          {...register(16)}
          gridColumn="span 3"
        />

        <Box gridColumn="span 7" />

        <SLabel>構成品を含む</SLabel>
        <SCodeCheck name="setshohinCheck" on={1} off={0} />

        <SNormalButton
          label={labels.buttons.search}
          gridRow="10"
          gridColumn="span 18"
          align="right"
          {...register(28)}
          onClick={handleClickSearchButtun}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          width={1280}
          height={400}
          handleDoubleClick={handleDoubleClickTableRow}
          onRowClick={handleRowClick}
          pageSize={pageSize}
          onPageChange={handleResetSearch}
        />
      </SFrame>

      <SFrame gridTemplateColumns="7rem 3rem 3rem 3rem 1rem 9rem 6rem 7rem 1rem 5rem 29rem 1rem">
        <SNormalButton
          label={labels.buttons.detail}
          gridRow="1"
          gridColumn="16"
          {...register(29)}
          onClick={handleShowDatail}
          disabled={disabledJuchuJuchuDetail}
        />
      </SFrame>
    </FormProvider>
  );
};
